function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 185.333 185.333"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M174.612 144.368a10.7 10.7 0 0 1-7.593-3.144L92.672 66.872l-74.347 74.352c-4.194 4.194-10.987 4.194-15.18 0-4.194-4.194-4.194-10.981 0-15.17l81.934-81.945c4.194-4.194 10.992-4.194 15.18 0l81.929 81.945a10.72 10.72 0 0 1 0 15.17 10.65 10.65 0 0 1-7.576 3.144",
    style: {
      fill: "#f73f69"
    }
  }));
};
export default SvgArrowUp;